var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snippets-wrapper"},_vm._l((_vm.list),function(snippet){return _c('div',{key:snippet.key,staticClass:"snippet",class:[ snippet.key === _vm.model && 'active' ],on:{"click":function($event){_vm.model = snippet.key}}},[_vm._v(" "+_vm._s(snippet.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }